import React from 'react';

const About = () => {
  return (
    <div className="pt-20 pb-20 bg-ivory min-h-screen">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl font-serif font-bold mb-4 text-navy">About</h1>
        <p className="font-sans text-navy/70">Extended about content</p>
      </div>
    </div>
  );
};

export default About;
